import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import img from "../../assets/Truck.jpg";

const initState = {
  title: "Trucking",
  subTitle: "Login",
};

const passReset = {
  title: "Password Reset",
  subTitle:
    "A one-time verification code will be sent to your inbox so you can reset your password.",
};

const LoginLayout = () => {
  const [header, setHeader] = useState(initState);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/forgot/password") {
      setHeader(passReset);
    } else {
      setHeader(initState);
    }
  }, [location]);

  return (
    <div className="bg-white font-family-karla h-screen">
      <div className="w-full flex flex-wrap">
        <div className="w-full md:w-1/2 flex flex-col">
          {/* <div className="flex justify-center md:justify-start pt-12 md:pl-12 md:-mb-24">
            <a href="#" className="bg-black text-white font-bold text-xl p-4">
              Logo
            </a>
          </div> */}

          <Outlet />
        </div>

        <div className="w-1/2 shadow-2xl">
          <img
            className="object-cover w-full h-screen hidden md:block"
            src={img}
            alt="background"
          />
        </div>
      </div>
    </div>
  );
};

export default LoginLayout;
